import { useEffect } from "react"

import {
  SavedContentSync,
  SavedContentSyncMessage,
} from "@/lib/saved-content-sync"
import { savedInspirationsApi } from "@/lib/storage/api/saved-inspirations-api"
import { useAppDispatch } from "@/lib/storage/hooks"
import { reloadSavedPlacesList } from "@/lib/storage/saved-thunks"

// sync saved content state (places and guides) across browser tabs
export function useSavedContentSync() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    const handleSyncMessage = (message: SavedContentSyncMessage) => {
      switch (message.contentType) {
        case "places":
          void dispatch(reloadSavedPlacesList())
          break
        case "guides":
          dispatch(savedInspirationsApi.util.invalidateTags(["SavedGuides"]))
          void dispatch(
            savedInspirationsApi.endpoints.getSavedGuidesList.initiate(
              undefined,
              {
                forceRefetch: true,
              }
            )
          )
          break
      }
    }

    SavedContentSync.instance.addListener(handleSyncMessage)

    return () => {
      SavedContentSync.instance.removeListener(handleSyncMessage)
    }
  }, [dispatch])
}
